<div class="p-field">
  <p-floatLabel variant="in">
    <input id="name" pInputText [(ngModel)]="editedSponsor.sponsorName" />
    <label for="name">Name des Kostenträgers</label>
  </p-floatLabel>
</div>
<div class="p-field">
  <p-floatLabel variant="in">
    <input
      id="contactperson"
      pInputText
      [(ngModel)]="editedSponsor.contactEmail"
    />
    <label for="contactperson">Kontakt-E-Mail</label>
  </p-floatLabel>
</div>

<div class="p-field">
  <p-floatLabel variant="in">
    <input
      id="contactemail"
      pInputText
      [(ngModel)]="editedSponsor.phoneNumber"
    />
    <label for="contactemail">Kontakt-Telefonnummer</label>
  </p-floatLabel>
</div>

<div class="p-field">
  <p-floatLabel variant="in">
    <input
      id="description"
      pInputText
      [(ngModel)]="editedSponsor.description"
    />
    <label for="description">Bemerkungen</label>
  </p-floatLabel>
</div>

<div class="form-buttons">
  <button
    pButton
    title="Speichern"
    type="button"
    label="Speichern"
    icon="pi pi-save"
    class="p-button-success"
    (click)="addKostentraeger()"
  ></button>
  <button
    pButton
    title="Abbrechen"
    type="button"
    label="Abbrechen"
    icon="pi pi-times"
    class="p-button-secondary"
    (click)="closeDialog()"
  ></button>
</div>
